import { DefaultPasswordPolicy, InvictusSourceType, RegexConstants, SettingsConstants } from '../../constants'

const objFunc = () => {
  return {
    authenticated: false,
    user: null,
    username: null,
    email: '',
    emailVerified: false,
    phone: '',
    phoneVerified: false,
    verified: false,
    password: '', // Should only be used temporarily when attempting to check that the user has verified their email address
    signOutInProgress: false,

    savedConfigSettings: false,
    sessionTimeoutStart: null,
    sessionTimeoutIsActive: false,
    sessionTimeoutSkip: false,
    sessionTimeoutLimit: SettingsConstants.sessionTimeoutMinutes,
    paymentTimeoutLimit: SettingsConstants.paymentTimeoutLimit,
    refiPaymentTimeoutLimit: SettingsConstants.refiPaymentTimeoutLimit,
    nlsRefiPaymentTimeoutLimit: SettingsConstants.nlsRefiPaymentTimeoutLimit,
    stickyHeaderId: SettingsConstants.stickyHeaderId,
    instaHeaderId: SettingsConstants.instaHeaderId,
    instaSidebarId: SettingsConstants.instaSidebarId,
    docuSignRedirect: false,
    allowNlsMlaCheck: SettingsConstants.allowNlsMlaCheck,
    allowNoSsnRefi: SettingsConstants.allowNoSsnRefi,
    previousPage: '',
    previousProps: {},
    allowManageNotifications: SettingsConstants.allowManageNotifications,
    displayTermsConditionsConsent: SettingsConstants.displayTermsConditionsConsent,
    disbursementMaxPollingAttempts: SettingsConstants.disbursementMaxPollingAttempts,
    trustedDeviceSettings: SettingsConstants.trustedDeviceSettings,
    serviceAvailable: true,
    servicesConfig: {
      clientId: process.env.VUE_APP_CognitoClientId,
      cognitoUrl: process.env.VUE_APP_CognitoUrl,
      serviceUrl: process.env.VUE_APP_TmxServicesUrl,
      userPoolId: process.env.VUE_APP_CognitoUserPoolId
    },
    internalRedirect: {},
    loanDocUploadFileTypes: SettingsConstants.loanDocUploadFileTypes,
    loanDocUploadInputTypes: SettingsConstants.loanDocUploadFileTypes,
    loanDocUploadMaxSize: SettingsConstants.loanDocUploadMaxSize, // MB
    pastDuePhoneDayLimit: SettingsConstants.pastDuePhoneDayLimit, // days
    menuItemVisibility: {},
    showIncompleteAppWarning: true,
    c1lPrivacyPolicyUrl: 'https://disclosures.ccffamilyofbrands.com/ccf/fed-privacy-notice',
    cccPrivacyPolicyUrl: 'https://disclosures.ccffamilyofbrands.com/ccf/fed-privacy-notice',
    ccfPrivacyPolicyUrl: 'https://disclosures.ccffamilyofbrands.com/ccf/fed-privacy-notice',
    chsPrivacyPolicyUrl: 'https://disclosures.ccffamilyofbrands.com/ccf/fed-privacy-notice',
    cicPrivacyPolicyUrl: 'https://disclosures.ccffamilyofbrands.com/ccf/fed-privacy-notice',
    esmPrivacyPolicyUrl: 'https://disclosures.ccffamilyofbrands.com/ccf/fed-privacy-notice',
    inlPrivacyPolicyUrl: 'https://disclosures.ccffamilyofbrands.com/ccf/fed-privacy-notice',
    tmxPrivacyPolicyUrl: 'https://disclosures.ccffamilyofbrands.com/ccf/fed-privacy-notice',
    c1lTermsConditionsUrl: 'https://www.tmxdisclosures.com/titlemax/ecommerce-credit-application-terms-and-conditions',
    cccTermsConditionsUrl: 'https://www.californiacheckcash.com/terms-of-use/',
    ccfTermsConditionsUrl: 'https://www.tmxdisclosures.com/titlemax/ecommerce-credit-application-terms-and-conditions',
    chsTermsConditionsUrl: 'https://assets-us-01.kc-usercontent.com/673ea2f7-d1db-0049-fc7b-f932cff71cf7/77013c84-9057-45be-b2d7-4e1829fdde75/terms-of-use.pdf',
    cicTermsConditionsUrl: 'https://www.tmxdisclosures.com/check-into-cash/cic-credit-application-additional-terms-and-conditions',
    esmTermsConditionsUrl: 'https://www.tmxdisclosures.com/easymoney/em-credit-application-additional-terms-and-conditions',
    deviceDetection: {
      mobileDeviceTest1: RegexConstants.mobileDeviceTest1,
      mobileDeviceTest2: RegexConstants.mobileDeviceTest2
    },
    canUploadNlsLoanDocuments: false,
    canUploadTlxeLoanDocuments: false,
    canUseCleverTap: false,
    settlementPaymentRetryLimit: SettingsConstants.settlementPaymentRetryLimit,
    canUseDisbursementPolling: false,
    displayReferralBalanceHistory: false,
    displayNonCustomerReferral: false,
    displayRetailReferral: false,
    outForRepoConfig: {},
    forceShowProductSwitchModal: false,
    forceShowRenewalStatement: false,
    checkAddonGps: true,
    checkPaymentGps: true,
    checkRefiGps: true,
    forceAddonGps: true,
    forcePaymentGps: true,
    forceRefiGps: true,
    gpsPosition: {
      latitude: '',
      longitude: ''
    },
    shareBirdEyeEnabled: false,
    shareTitlemaxEnabled: true,
    canSendVoiceMessages: false,
    fromLegacyNcr: false,

    passwordPolicy: {
      minimumLength: DefaultPasswordPolicy.minimumLength,
      requireLowercase: DefaultPasswordPolicy.requireLowercase,
      requireNoSpaces: DefaultPasswordPolicy.requireNoSpaces,
      requireNumbers: DefaultPasswordPolicy.requireNumbers,
      requireSymbols: DefaultPasswordPolicy.requireSymbols,
      requireUppercase: DefaultPasswordPolicy.requireUppercase
    },

    restrictManualRetry: true,
    restrictedRetryTimeInMins: SettingsConstants.restrictedRetryTimeInMins,
    logNonFatalErrors: true,
    wrongPasswordRedirectCount: 3,
    bridgePaySettings: {},
    loanOriginateTimeout: SettingsConstants.loanOriginateTimeout,
    postDrawTimeout: SettingsConstants.postDrawTimeout,
    debtSoldConfig: {},
    isInvictus: false,
    shortFormLoanType: '',
    salesForceId: '',
    languageIndicator: '',
    trafficChannel: '',
    invitationCode: '',
    state: '',
    zip: '',
    firstName: '',
    lastName: '',
    redirectUrl: '',
    duplicateEmail: '',
    invictusSource: InvictusSourceType.None,
    invictusUrlInfo: {},
    newInvictusCustomer: false,
    updateInvictusProfile: false,
    canEditPhone: false,
    canEditEmail: false,
    canEditEmailInvictus: false,

    securityQuestions: [],
    answeredSecurityQuestion: {}
  }
}

export default objFunc()

export const defaultObj = objFunc()
